var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClaim = function SvgClaim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 71.045,
    viewBox: "0 0 99 71.045"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9EAEB",
    d: "M41.546 42.164a28.727 28.727 0 1 0 57.454 0c0-15.866-12.862-28.727-28.727-28.727S41.546 26.298 41.546 42.164z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A5082",
    d: "M67.956 71.045H24.711V7.722h43.245z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M27.8 67.956h37.067V10.811H27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9EAEB",
    d: "M30.89 1.544h30.888v7.723H30.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A5082",
    d: "M63.323 10.811H29.345V0h33.978v10.811zm-30.89-3.089h27.801V3.09h-27.8v4.633z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9EAEB",
    d: "M43.245 57.145h9.267v12.356h-9.267z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A5082",
    d: "M54.056 71.045H41.7V55.601h12.356v15.444zm-9.267-3.089h6.178V58.69H44.79v9.266zM43.245 30.89h-3.089v-6.178h-4.633v6.178h-3.09v-9.267h10.812v9.267zm0 12.356h-3.089v-6.178h-4.633v6.178h-3.09v-9.267h10.812v9.267zM27.8 71.045H9.267v-41.7H27.8v41.7zm-15.444-3.089H24.71V32.434H12.356v35.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9EAEB",
    d: "M15.445 23.167h10.81v7.722h-10.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A5082",
    d: "M27.8 32.434H13.9V21.622h13.9v10.812zm-10.81-3.09h7.721v-4.633H16.99v4.634zM6.178 67.956H83.4v3.09H6.178zm-6.178 0h3.089v3.09H0v-3.09zm86.49 0h6.178v3.09H86.49v-3.09zm9.267 0h3.089v3.09h-3.09v-3.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3D4FF",
    d: "M93.938 29.06h-11.73l2.958 2.849-15.094 15.055-7.956-7.934-16.522 16.58 5.711 5.8 10.097-10.072 7.956 7.833 21.52-21.464 3.06 3.052z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A5082",
    d: "M51.169 63 44 55.734 62.127 37.62l7.987 7.982 13.62-13.713L79.845 28H95v15.249l-4.096-4.094-21.609 21.594-7.988-7.983L51.17 63zm-4.302-7.266 4.302 4.4 10.138-10.131 7.988 7.982L90.904 36.29l2.048 2.047V30.15h-8.193l1.843 1.842-16.59 16.477-7.988-7.983-15.157 15.249z"
  }))));
};
export default SvgClaim;